var _a;
import { createSelector, createSlice } from '@reduxjs/toolkit';
var initialState = {
    isDialogueOpen: false,
    dialogueParams: null
};
export var gieLinksSlice = createSlice({
    name: 'gieLinks',
    initialState: initialState,
    reducers: {
        openGieLinksDialogue: function (state, _a) {
            var payload = _a.payload;
            state.dialogueParams = payload;
            state.isDialogueOpen = true;
        },
        closeGieLinksDialogue: function (state) {
            state.isDialogueOpen = false;
        }
    }
});
export var openGieLinksDialogue = (_a = gieLinksSlice.actions, _a.openGieLinksDialogue), closeGieLinksDialogue = _a.closeGieLinksDialogue;
export var selectIsGieLinksDialogueOpen = createSelector([function (state) { return state.gieLinks; }], function (state) { return state.isDialogueOpen; });
export var selectGieLinksDialogueParams = createSelector([function (state) { return state.gieLinks; }], function (state) { return state.dialogueParams; });
